import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year5/Autumn/FractionsA/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'FractionsA',
  field: 'Number',
  weeks: [9, 12],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/1FindFractionsEquivalentToAUnitFraction" */ './1FindFractionsEquivalentToAUnitFraction'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/2FindFractionsEquivalentToANonUnitFraction" */ './2FindFractionsEquivalentToANonUnitFraction'
        )
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/3RecogniseEquivalentFractions" */ './3RecogniseEquivalentFractions'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/4ConvertImproperFractionsToMixedNumbers" */ './4ConvertImproperFractionsToMixedNumbers'
        )
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/5ConvertMixedNumbersToImproperFractions" */ './5ConvertMixedNumbersToImproperFractions'
        )
    }),
    // Step 6
    newSmallStepContent({
      ...BlockModel.smallSteps[5],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/6CompareFractionsLessThan1" */ './6CompareFractionsLessThan1'
        )
    }),
    // Step 7
    newSmallStepContent({
      ...BlockModel.smallSteps[6],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/7OrderFractionsLessThan1" */ './7OrderFractionsLessThan1'
        )
    }),
    // Step 8
    newSmallStepContent({
      ...BlockModel.smallSteps[7],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/8CompareAndOrderFractionsGreaterThan1" */ './8CompareAndOrderFractionsGreaterThan1'
        )
    }),
    // Step 9
    newSmallStepContent({
      ...BlockModel.smallSteps[8],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/9AddAndSubtractFractionsWithTheSameDenominator" */ './9AddAndSubtractFractionsWithTheSameDenominator'
        )
    }),
    // Step 10
    newSmallStepContent({
      ...BlockModel.smallSteps[9],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/10AddFractionsWithin1" */ './10AddFractionsWithin1'
        )
    }),
    // Step 11
    newSmallStepContent({
      ...BlockModel.smallSteps[10],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/11AddFractionsWithTotalGreaterThan1" */ './11AddFractionsWithTotalGreaterThan1'
        )
    }),
    // Step 12
    newSmallStepContent({
      ...BlockModel.smallSteps[11],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/12AddToAMixedNumber" */ './12AddToAMixedNumber'
        )
    }),
    // Step 13
    newSmallStepContent({
      ...BlockModel.smallSteps[12],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/13AddTwoMixedNumbers" */ './13AddTwoMixedNumbers'
        )
    }),
    // Step 14
    newSmallStepContent({
      ...BlockModel.smallSteps[13],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/14SubtractFractions" */ './14SubtractFractions'
        )
    }),
    // Step 15
    newSmallStepContent({
      ...BlockModel.smallSteps[14],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/15SubtractFromAMixedNumber" */ './15SubtractFromAMixedNumber'
        )
    }),
    // Step 16
    newSmallStepContent({
      ...BlockModel.smallSteps[15],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/16SubtractFromAMixedNumberBreakingTheWhole" */ './16SubtractFromAMixedNumberBreakingTheWhole'
        )
    }),
    // Step 17
    newSmallStepContent({
      ...BlockModel.smallSteps[16],
      module: () =>
        import(
          /* webpackChunkName: "Year5/Autumn/FractionsA/17SubtractTwoMixedNumbers" */ './17SubtractTwoMixedNumbers'
        )
    })
  ]
});
export default Block;
